import { parseBlocks, taskMarks } from "@/lib/markdown-blocks";

/** Whatever may precede the checkbox on its line: indent, `>` quote markers, list markers. */
const BEFORE_BOX = /^((?:[ \t>]|[-*+](?=[ \t])|\d{1,9}[.)](?=[ \t]))*)\[([ xX])\]/;

/**
 * The description with its `index`-th checkbox (0-based, in the order they are
 * drawn) flipped between `[ ]` and `[x]`, and not one other character changed —
 * line endings included, since the text is stored back as the user wrote it.
 * The box is found with the renderer's own parse, so a `- [ ]` inside a fenced
 * block is never counted. An index with no checkbox returns the text unchanged.
 */
export function toggleTaskListItem(text: string, index: number): string {
  const mark = taskMarks(parseBlocks(text))[index];
  if (!mark) return text;

  // Even entries are lines, odd ones the separator that ended them.
  const parts = text.split(/(\r\n|\r|\n)/);
  const at = mark.line * 2;
  const line = parts[at];
  if (line === undefined) return text;
  const match = line.match(BEFORE_BOX);
  if (!match) return text;

  const prefix = match[1]!;
  const next = match[2] === " " ? "x" : " ";
  parts[at] = `${prefix}[${next}]${line.slice(match[0].length)}`;
  return parts.join("");
}
